import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  customerOpenIssues: any = 0;

  constructor(
    private toast: ToastrService,
    private ngxService: NgxUiLoaderService,
    private cookieService: CookieService,
    private router: Router,
  ) { }

  showSuccess(msg: string): void {
    this.toast.success(msg);
  }

  showError(err: any): void {
    const errMsg = err.message ? err.message : err.detail;
    this.toast.error(errMsg);
  }

  showLoader(): void {
    this.ngxService.start();
  }

  hideLoader(): void {
    this.ngxService.stop();
  }

  redirectToLanding() {
    this.router.navigate(['/']);
  }

  deleteStoredCookies() {
    if (location.href.indexOf('.shadowfax.in') !== -1) {
      this.cookieService.delete('sfxTrackToken', '/', '.shadowfax.in');
      this.cookieService.delete('awb_number', '/', '.shadowfax.in');
      this.cookieService.delete('order_id', '/', '.shadowfax.in');
      this.cookieService.delete('maskedCustomerNumber', '/', '.shadowfax.in');
      this.cookieService.delete('request_type', '/', '.shadowfax.in');
    } else {
      this.cookieService.delete('sfxTrackToken', '/', 'localhost');
      this.cookieService.delete('awb_number', '/', 'localhost');
      this.cookieService.delete('order_id', '/', 'localhost');
      this.cookieService.delete('maskedCustomerNumber', '/', 'localhost');
      this.cookieService.delete('request_type', '/', 'localhost');
    }
  }

  deleteCookie(key: string) {
    if (location.href.indexOf('.shadowfax.in') !== -1) {
      this.cookieService.delete(key, '/', '.shadowfax.in');
    } else {
      this.cookieService.delete(key, '/', 'localhost');
    }
  }

  setCookie(key: string, value: any) {
    this.cookieService.set(key, value)
  }

  getCookie(key: string) {
    return this.cookieService.get(key) || null;
  }

  isMobile() {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
  }

  safeBtoa(str: string): string {
	return btoa(
	  encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, 
		(match, p1) => String.fromCharCode(parseInt(p1, 16))
	  )
	);
  }

  safeAtob(encoded: string): string {
	return decodeURIComponent(
	  Array.from(atob(encoded))
		   .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
		   .join('')
	);
  }

}
